import { useCallback, useEffect, useState } from "react";
import { Checkbox, Spin, Table, Tag } from "antd";
import type { TableColumnsType } from "antd";
import { AdminListShell } from "../components/admin/AdminListShell";
import { fetchAdminAlertPrefsPage } from "../api/client";
import type { AdminAlertPrefRow } from "../api/types";

export function AlertPrefsPage() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [enabledOnly, setEnabledOnly] = useState(false);
  const [items, setItems] = useState<AdminAlertPrefRow[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<"forbidden" | "error" | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    const r = await fetchAdminAlertPrefsPage({
      page,
      page_size: pageSize,
      enabled_only: enabledOnly || undefined,
    });
    if (r === "forbidden") setErr("forbidden");
    else if (r === "error") setErr("error");
    else {
      setItems(r.items);
      setTotal(r.total);
    }
    setLoading(false);
  }, [page, pageSize, enabledOnly]);

  useEffect(() => {
    void load();
  }, [load]);

  useEffect(() => {
    setPage(1);
  }, [enabledOnly]);

  const columns: TableColumnsType<AdminAlertPrefRow> = [
    { title: "用户邮箱", dataIndex: "user_email", key: "em", width: 220, ellipsis: true },
    {
      title: "已开启",
      dataIndex: "enabled",
      width: 88,
      align: "center",
      render: (v: boolean) => (v ? <Tag color="green">是</Tag> : <Tag>否</Tag>),
    },
    { title: "频率", dataIndex: "frequency", key: "fq", width: 120 },
    {
      title: "用户ID",
      dataIndex: "user_id",
      width: 130,
      render: (id: string) => <span className="admin-ledger-mono">{id.slice(0, 8)}…</span>,
    },
  ];

  return (
    <AdminListShell
      title="通知偏好"
      description="用户监管邮件通知开关与频率（无正文）。"
      err={err}
      errorBanner
      toolbar={
        <div className="admin-ledger-toolbar" style={{ padding: "8px 12px" }}>
          <Checkbox checked={enabledOnly} onChange={(e) => setEnabledOnly(e.target.checked)}>
            仅显示已开启
          </Checkbox>
        </div>
      }
      table={(bodyY) => (
        <div className="admin-ledger-table-wrap admin-ledger-table-wrap--flex">
          <Spin spinning={loading}>
            <Table<AdminAlertPrefRow>
              rowKey="id"
              className="admin-ledger-table"
              columns={columns}
              dataSource={items}
              pagination={{
                current: page,
                pageSize,
                total,
                showSizeChanger: true,
                pageSizeOptions: [10, 20, 50],
                showTotal: (t) => `共 ${t} 条`,
                onChange: (p, ps) => {
                  setPage(p);
                  setPageSize(ps);
                },
              }}
              scroll={{ x: 800, y: bodyY }}
              locale={{ emptyText: "暂无记录" }}
            />
          </Spin>
        </div>
      )}
    />
  );
}
